// src/services/socket.js
import { io } from "socket.io-client";

let socket = null;

export const initSocket = (hotelId) => {
  if (!socket) {
    socket = io("https://socket-dev.etableapp.in", {
      path: "/socket.io/",
      transports: ["websocket", "polling"],
    });

    socket.on("connect", () => {
      console.log(`✅ Socket.IO connected: ${socket.id}`);
      socket.emit("join-hotel", hotelId);
    });

    socket.on("connect_error", (error) => {
      console.error("❌ Connection error:", error);
    });
  }

  return socket;
};

export const getSocket = () => socket;

export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};
